/**
 * Self-serve signup (Stage 5, decisions.md): somebody signed in makes an
 * organisation, becomes its first admin, and starts on Free.
 *
 * The worker opens signup only when Turnstile is set up; this file is what a
 * request has to say to be let through once it is. The cap is per account,
 * not per address or per IP: an account is already a proven address, so the
 * cap is what stops one proven address making organisations without end. A
 * consultant who needs more asks utuwrk, whose console has no cap.
 */

/** Organisations one account may make for itself. */
export const SIGNUPS_PER_ACCOUNT = 3;

/** As the console's own limit. */
export const ORGANIZATION_NAME_LENGTH = 120;

export type SignupCheck = { ok: true; name: string } | { ok: false; reason: string };

/** The name to make it under, or why not. `made` is how many this account has made already. */
export function checkSignup(name: unknown, made: number): SignupCheck {
  const clean = String(name ?? "")
    .trim()
    .slice(0, ORGANIZATION_NAME_LENGTH);
  if (!clean) return { ok: false, reason: "An organisation needs a name." };
  if (made >= SIGNUPS_PER_ACCOUNT)
    return {
      ok: false,
      reason: `You have made ${SIGNUPS_PER_ACCOUNT} organisations already. Write to utuwrk to make another.`,
    };
  return { ok: true, name: clean };
}
